import {
    isRouteErrorResponse,
    Links,
    Meta,
    Outlet,
    Scripts,
    ScrollRestoration,
} from "react-router";
import CircularProgress from '@mui/material/CircularProgress';

import { useContext } from 'react';

import { SearchProvider } from 'src/context/SearchContext';
import Header from 'src/components/Header';
import Footer from 'src/components/Footer';
import { headers } from 'src/util/Util';

// import 'src/assets/fonts/iconos/iconos.css';
import "src/css/main.scss";
import 'src/css/Nav.scss';
import 'simplebar-react/dist/simplebar.min.css';

const ITEMS_EP = import.meta.env.VITE_ITEMS_EP;
const BASE_URL = import.meta.env.VITE_BASE_URL || '/';

export function meta() {
    return [
        { title: "Histopatología veterinaria" },
        { name: "description", content: "Laboratorio virtual de patología veterinaria" },
    ];
}

export const links = () => [
    { rel: "preconnect", href: "https://fonts.googleapis.com" },
    {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "anonymous",
    },
    {
        rel: "stylesheet",
        href: 'https://fonts.googleapis.com/css2?family=Fjalla+One:wght@300;400;600&display=swap',
    },
    {
        rel: "stylesheet",
        href: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap',
    },
    {
        rel: "stylesheet",
        href: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;600&display=swap',
    },
    {
        rel: "icon",
        href: BASE_URL + 'img/imagotipo.svg',
        type: 'image/svg+xml'
    },
];

export function Layout({ children }) {
    return (
        <html lang="en">
            <head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <Meta />
                <Links />
            </head>
            <body>
                <SearchProvider>
                    <div className="page">
                        <Header />
                        {children}
                        <Footer />
                    </div>
                </SearchProvider>
                <ScrollRestoration getKey={location => location.pathname}/>
                <Scripts />
            </body>
        </html>
    );
}

export default function App() {
    return (
        <Outlet />
    );
}

export function ErrorBoundary({ error }) {
    let details = "Lo sentimos, ocurrió algo inesperado.";
    let desc = "Intenta recargar la página.";
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            details = "Lo sentimos, esa página no existe.";
            desc = "";
        }
    }

    return (
        <main className="error">
            <div className="intro"></div>
            <h3>{details}</h3>
            <p>{desc}</p>
        </main>
    );
}

export function HydrateFallback() {
    return (
        <main className="loading">
            <div className="intro"></div>
            <CircularProgress />
            <p>Cargando...</p>
        </main>
    );
}



